import { Component } from "@angular/core";

@Component({
    selector: "brand",
    templateUrl: "./brand.component.html"
})
export class BrandComponent {

}


// WEBPACK FOOTER //
// ./src/app/public/brand/brand.component.ts